import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-primary-400 to-secondary-500 text-background-50">
                <i className="ri-hearts-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">美丽的小蜜桃</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              把分散的爆料、绯闻与私密讨论线索归拢到一处，按时间与话题整理，帮你在追瓜之前先看清脉络。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-reddit-fill", "ri-mail-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="cursor-pointer">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-secondary-300/70 pt-6">
          <p className="text-xs leading-relaxed text-foreground-600">
            本站为娱乐话题与线索整理展示站点，所有条目均为演示性内容，与任何真实人物、事件无关；如涉及权利问题，请通过反馈通道联系处理。
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-600">© 2026 美丽的小蜜桃 · 瓜料线索整理站</p>
            <p className="text-xs text-foreground-600">演示站点 · 内容仅供浏览</p>
          </div>
        </div>
      </div>
    </footer>
  );
}